import {UAParser} from 'ua-parser-js';

const emptyDeviceInfo = {os: 'unknown', device: 'unknown', browser: undefined};

export const getDeviceInfoByUserAgent = (userAgent: string | null) => {
  if (!userAgent) {
    return emptyDeviceInfo;
  }
  const parser = new UAParser(userAgent);
  const parserResults = parser.getResult();
  const os = parserResults?.os?.name ?? 'unknown';
  const device = parserResults?.device?.type ?? 'desktop';
  const browser = parserResults?.browser?.name;

  return {
    os: os.toLowerCase(),
    device: device.toLowerCase(),
    browser: browser?.toLowerCase(),
  };
};

export const getDeviceInfo = () => {
  if (typeof window === 'undefined') return emptyDeviceInfo;

  return getDeviceInfoByUserAgent(navigator.userAgent);
};
